import React, { useContext } from 'react';
import { DispatchContext, StateContext } from '../../state/contexts';
import '../default/theme.scss';
import Filters from '../../filters/filters';
import ErrorFallback from '../../components/error-fallback';
import LoadingIndicator from '../../components/loading-indicator';
import JobListWithPagination from '../../jobs/job-list-with-pagination';
import themeConfig from '../default/theme-config';
import useTheme from '../../hooks/use-theme';
import JobCard from '../../jobs/job-card';
import JobList from '../../jobs/job-list';

const Theme = () => {
  const state = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const { config, data } = state;

  useTheme(config, dispatch, themeConfig);

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <Filters className="row-cols-sm-2 row-cols-lg-3" />
        </div>

        <div className="col-12">
          {data.type === 'error' && <ErrorFallback error={data.error} resetErrorBoundary={data.retry} />}
          {data.type === 'loading' && <LoadingIndicator />}
          {data.type === 'processed' && <JobListWithPagination List={JobList} Card={JobCard} />}
        </div>
      </div>
    </div>
  );
};

export default Theme;
